import { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, TextField, Button, Typography, Box, Stack, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { GOLD, GOLD2, GOLDF, DARK } from '../theme/theme';

const INITIAL = { name: '', mobile: '', email: '', location: '', requirement: '', message: '' };

const goldField = {
  '& label': { color: '#888' },
  '& label.Mui-focused': { color: GOLD },
  '& .MuiInputBase-input': { color: '#333' },
  '& .MuiOutlinedInput-root': {
    bgcolor: '#fff',
    '& fieldset': { borderColor: 'rgba(184,134,11,0.30)' },
    '&:hover fieldset': { borderColor: GOLD },
    '&.Mui-focused fieldset': { borderColor: GOLD },
  },
};

export default function EnquiryModal({ open, onClose }) {
  const [form, setForm] = useState(INITIAL);
  const [error, setError] = useState('');
  const [sent, setSent]   = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = () => {
    if (!form.name.trim()) return setError('Please enter your name.');
    if (!/^\+?[\d\s]{8,}$/.test(form.mobile)) return setError('Please enter a valid mobile number.');
    setError('');
    setSent(true);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth
      PaperProps={{ sx: { bgcolor: '#fff', borderRadius: '16px', border: `1.5px solid ${GOLD}`, boxShadow: '0 8px 40px rgba(0,0,0,0.18)' } }}>
      <DialogTitle sx={{ pb: 0.5, pt: 2.5, px: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <Typography sx={{ fontFamily: "'Cinzel',Georgia,serif", fontWeight: 700, fontSize: '16px', letterSpacing: '0.10em', color: DARK }}>
              Book a Free Site Visit
            </Typography>
            <Typography sx={{ fontSize: 12, color: '#888', mt: 0.3 }}>Our advisor will call within 2 hours</Typography>
          </Box>
          <IconButton onClick={onClose} size="small" sx={{ color: '#aaa', '&:hover': { color: GOLD } }}><CloseIcon fontSize="small" /></IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ px: 3, pb: 3 }}>
        {sent ? (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Box sx={{ width: 56, height: 56, borderRadius: '50%', bgcolor: GOLD, display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 2 }}>
              <Typography sx={{ fontSize: 24, color: '#fff' }}>✓</Typography>
            </Box>
            <Typography sx={{ fontFamily: "'Cinzel',serif", fontWeight: 700, fontSize: '15px', color: DARK, mb: 1 }}>Request Received!</Typography>
            <Typography sx={{ fontSize: 13, color: '#777' }}>We'll contact you within 2 hours.</Typography>
          </Box>
        ) : (
          <Stack spacing={2} mt={1.5}>
            <TextField fullWidth label="Full Name *" value={form.name} onChange={update('name')} size="small" sx={goldField} />
            <TextField fullWidth label="Mobile *" value={form.mobile} onChange={update('mobile')} size="small" sx={goldField} />
            <TextField fullWidth label="Email" value={form.email} onChange={update('email')} size="small" sx={goldField} />
            <TextField fullWidth label="Preferred Location" value={form.location} onChange={update('location')} size="small" sx={goldField} />
            <TextField fullWidth label="Message" value={form.message} onChange={update('message')} multiline rows={2} size="small" sx={goldField} />
            {error && <Typography sx={{ color: '#d32f2f', fontSize: 12 }}>{error}</Typography>}
            <Button fullWidth onClick={submit} startIcon={<CalendarMonthIcon />} sx={{
              bgcolor: GOLD, color: '#fff', fontWeight: 800, py: 1.3, borderRadius: '10px',
              fontSize: '13px', letterSpacing: '0.05em',
              '&:hover': { bgcolor: GOLD2 },
            }}>
              Confirm Site Visit
            </Button>
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );
}
